<script lang="ts" setup>
const _props = defineProps<{
  variant?: 'back'
}>()
const emit = defineEmits(['click'])
</script>

<template>
  <button
    class="font-display inline-flex cursor-pointer items-center text-base "
    @click="() => emit('click')"
  >
    <IconsArrowLeft v-if="variant && variant == 'back'" class="mr-3 size-5" />
    <slot />
    <IconsArrowRight v-if="!variant || variant != 'back'" class="ml-3 size-5" />
  </button>
</template>
